import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import LOGO_OLIMPICA from "../../assets/images/logo-Olimpica.png";
import LOGO_IDTOLU from "../../assets/images/logoIdt.svg";

import {
  FaRegChartBar,
  FaMap,
  FaTh,
  FaRegBell,
  FaClipboardList,
  FaCalendarAlt,
  FaProductHunt,
  FaProjectDiagram,
} from "react-icons/fa";
import {
  AiOutlineFundProjectionScreen,
  AiOutlineUsergroupAdd,
  AiOutlineSetting,
  AiFillSound,
  AiFillEyeInvisible,
} from "react-icons/ai";
import { useKeycloakRoles } from "../../context/auth-roles";

const ROLE_LOGO = {
  superAdmin: LOGO_OLIMPICA,
  admin: LOGO_OLIMPICA,
  viewer: LOGO_OLIMPICA,
  demo: LOGO_IDTOLU,
};

function getItem(key, label) {
  return { key, label };
}

export default function SideNav(props) {
  const { pathname } = useLocation();
  const activeKey = pathname === "/" ? "/" : pathname.slice(1);
  const { t } = useTranslation("global");
  const { hasResourceRole } = useKeycloakRoles("IDT-IDT-DTC-IOT-013");

  const roleConfig = useMemo(
    () => ({
      superAdmin: [
        { path: "/", icon: <FaTh />, label: t("sidenav.dashboard") },
        {
          path: "device",
          icon: <AiOutlineFundProjectionScreen />,
          label: t("sidenav.device"),
        },
        {
          path: "unifilar",
          icon: <FaProjectDiagram />,
          label: t("sidenav.unifilar"),
        },
        { path: "locations", icon: <FaMap />, label: t("sidenav.locations") },
        { path: "report", icon: <FaRegChartBar />, label: t("sidenav.report") },
        {
          path: "notification",
          icon: <FaRegBell />,
          label: t("sidenav.notification"),
        },
        {
          path: "products",
          icon: <FaProductHunt />,
          label: t("sidenav.products"),
        },
        { path: "alert", icon: <AiFillSound />, label: t("sidenav.alert") },
      ],
      admin: [
        { path: "/", icon: <FaTh />, label: t("sidenav.dashboard") },
        {
          path: "device",
          icon: <AiOutlineFundProjectionScreen />,
          label: t("sidenav.device"),
        },
        {
          path: "unifilar",
          icon: <FaProjectDiagram />,
          label: t("sidenav.unifilar"),
        },
        {
          path: "device-inactive",
          icon: <AiFillEyeInvisible />,
          label: t("sidenav.device-inactive"),
        },
        {
          path: "scheduled",
          icon: <FaCalendarAlt />,
          label: t("sidenav.automation"),
        },
        { path: "locations", icon: <FaMap />, label: t("sidenav.locations") },
        { path: "report", icon: <FaRegChartBar />, label: t("sidenav.report") },
        {
          path: "files-reports",
          icon: <FaClipboardList />,
          label: t("sidenav.list-report"),
        },
        { path: "alert", icon: <AiFillSound />, label: t("sidenav.alert") },
        {
          path: "users",
          icon: <AiOutlineUsergroupAdd />,
          label: t("sidenav.user"),
        },
        {
          path: "config",
          icon: <AiOutlineSetting />,
          label: t("sidenav.configAlert"),
        },
        {
          path: "notification",
          icon: <FaRegBell />,
          label: t("sidenav.notification"),
        },
      ],
      viewer: [
        { path: "/", icon: <FaTh />, label: t("sidenav.dashboard") },
        { path: "report", icon: <FaRegChartBar />, label: t("sidenav.report") },
       
        { path: "alert", icon: <AiFillSound />, label: t("sidenav.alert") },
      ],
      demo: [
        { path: "/", icon: <FaTh />, label: t("sidenav.dashboard") },
        {
          path: "device",
          icon: <AiOutlineFundProjectionScreen />,
          label: t("sidenav.device"),
        },
        {
          path: "unifilar",
          icon: <FaProjectDiagram />,
          label: t("sidenav.unifilar"),
        }, 
        { path: "locations", icon: <FaMap />, label: t("sidenav.locations") },
        { path: "report", icon: <FaRegChartBar />, label: t("sidenav.report") },
        { path: "alert", icon: <AiFillSound />, label: t("sidenav.alert") },
        {
          path: "notification",
          icon: <FaRegBell />,
          label: t("sidenav.notification"),
        },
      ],
    }),
    [t],
  );

  const rol =
    Object.keys(roleConfig).find((role) => hasResourceRole(role)) ?? "viewer";

  const items = useMemo(
    () =>
      roleConfig[rol].map((item) =>
        getItem(
          item.path,
          <Link to={item.path} className="nav-link">
            <span
              className="icon"
              style={{ background: activeKey === item.path ? props.color : "" }}
            >
              {item.icon}
            </span>
            <span className="label">{item.label}</span>
          </Link>,
        ),
      ),
    [roleConfig, rol, activeKey, props.color],
  );

  return (
    <>
      <div className="brand">
        <img
          src={ROLE_LOGO[rol] ?? LOGO_OLIMPICA}
          width="170px"
          height="250px"
          alt=""
        />
      </div>
      <div>
        <Menu
          mode="inline"
          theme="light"
          selectedKeys={[activeKey]}
          items={items}
        />
      </div>
    </>
  );
}
